import { render, staticRenderFns } from "./halfBall.vue?vue&type=template&id=1713bebd&scoped=true&"
import script from "./halfBall.vue?vue&type=script&lang=js&"
export * from "./halfBall.vue?vue&type=script&lang=js&"
import style0 from "./halfBall.vue?vue&type=style&index=0&id=1713bebd&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1713bebd",
  null
  
)

export default component.exports